import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import InvoiceExemptionsTable from "@/components/invoices/exemptions/exemptions-table";

const exemptionsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/invoices/exemptions/",
)({
  validateSearch: exemptionsSearchSchema,
  component: InvoicesExemptionsPage,
});

function InvoicesExemptionsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "invoices_exemptions", actions: ["read"] }]}>
      
    <div className="space-y-4">
      <InvoiceExemptionsTable
        currentPage={searchParams.page}
        basePath="/invoices/exemptions"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
